import { ErrorToast, SuccessToast } from '../toasters';

export async function copyToClipboard(text: string) {
    try {
        await navigator.clipboard.writeText(text);
        SuccessToast('Successfully copied');
    } catch {
        ErrorToast('Failed to copy');
    }
}
